import { useCallback, useEffect, useRef } from 'react';

/**
 * setTimeout whose pending callbacks are cancelled when the component
 * unmounts. Scheduling after unmount (e.g. from a save flushed on unmount)
 * is a no-op.
 */
const useScheduledTimeouts = () => {
  const timeoutIdsRef = useRef(new Set());
  const unmountedRef = useRef(false);

  useEffect(() => {
    const timeoutIds = timeoutIdsRef.current;
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
      timeoutIds.forEach((timeoutId) => clearTimeout(timeoutId));
      timeoutIds.clear();
    };
  }, []);

  return useCallback((callback, delay) => {
    if (unmountedRef.current) return;
    const timeoutId = setTimeout(() => {
      timeoutIdsRef.current.delete(timeoutId);
      callback();
    }, delay);
    timeoutIdsRef.current.add(timeoutId);
  }, []);
};

export default useScheduledTimeouts;
